import React from "react"

export const ErrorField = ({ name }) => {
    return (
        <span className="text-red text-xs font-normal font-['Avenir'] leading-[14px]">
            { name }
        </span>
    )
}
